import { type ReportNtpDisplayMode } from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import type { ReportPeriod } from '../../../utils/report-period.utils';
import { ReportDefaultSettingsKeys } from 'ag-common-lib/lib/models/reporting/report-default-settings.model';

export enum ReportDefaultSettingsFormKeys {
  period = ReportDefaultSettingsKeys.period,
  ntpDisplayMode = ReportDefaultSettingsKeys.ntpDisplayMode,
  showSuppressedAgents = ReportDefaultSettingsKeys.showSuppressedAgents,
  showTotals = ReportDefaultSettingsKeys.showTotals,
  title = ReportDefaultSettingsKeys.title,
  subtitle = ReportDefaultSettingsKeys.subtitle,
  displayThreshold = ReportDefaultSettingsKeys.displayThreshold,
  includeThreshold = ReportDefaultSettingsKeys.includeThreshold,
  rowsPerPage = ReportDefaultSettingsKeys.rowsPerPage,
  startDate = ReportDefaultSettingsKeys.startDate,
  endDate = ReportDefaultSettingsKeys.endDate,
  isPublic = ReportDefaultSettingsKeys.isPublic,
}

export class ReportDefaultSettingsFormData {
  [ReportDefaultSettingsFormKeys.ntpDisplayMode]: ReportNtpDisplayMode = 'separate';
  [ReportDefaultSettingsFormKeys.showSuppressedAgents]: boolean = false;
  [ReportDefaultSettingsFormKeys.showTotals]: boolean = true;
  [ReportDefaultSettingsFormKeys.period]: ReportPeriod = 'custom';
  [ReportDefaultSettingsFormKeys.title]: string = '';
  [ReportDefaultSettingsFormKeys.subtitle]: string = '';
  [ReportDefaultSettingsFormKeys.displayThreshold]: number = 0;
  [ReportDefaultSettingsFormKeys.includeThreshold]: boolean = true;
  [ReportDefaultSettingsFormKeys.rowsPerPage]: number = 1;
  [ReportDefaultSettingsFormKeys.startDate]: string = '';
  [ReportDefaultSettingsFormKeys.endDate]: string = '';
  [ReportDefaultSettingsFormKeys.isPublic]: boolean = false;
}
